
import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { AnimationsService } from 'src/app/services/animations/animations.service';

@Component({
  selector: 'app-certification',
  templateUrl: './certification.component.html',
  styleUrls: ['./certification.component.scss'],
  standalone: false  // ✅ required in Angular 20 to use in a NgModule

})
export class CertificationComponent implements AfterViewInit {

  active = 0;
  

next() {
  this.active = (this.active + 1) % this.certifications.length;
}

prev() {
  this.active =
    (this.active - 1 + this.certifications.length) %
    this.certifications.length;
}

  certifications = [
   
    {
    title: 'ISTQB CTFL v4.0',
    date: 'May 2026',
    image: 'assets/certs/one.JPG',
    description: 'Certified Tester Foundation Level',
    tags: ['QA', 'Testing', 'ISTQB']
  },
   {
    title: 'Software Quality & Testing',
    date: '2026',
    image: 'assets/certs/two.JPG',
    description: 'QA methodologies and test design techniques',
    tags: ['QA', 'Testing']
  },
  {
    title: 'Angular 16 — Udemy',
    date: '2024',
    image: 'assets/certs/three.JPG',
    description: 'Formation Angular avancée avec RxJS et architecture moderne',
    tags: ['Angular', 'Frontend', 'RxJS']
  },
  {
    title: 'Java Full Stack',
    date: '2021',
    image: 'assets/certs/four.JPG',
    description: 'Spring Boot + Angular full stack development',
    tags: ['Java', 'Spring Boot', 'Angular']
  },
  
  
  {
    title: 'PHP Web Development',
    date: '2021',
    image: 'assets/certs/five.JPG',
    description: 'PHP, MySQL, GitHub & deployment',
    tags: ['PHP', 'MySQL', 'Git' , 'Heroku'] 
  }
];

  constructor(
    private animationsService: AnimationsService,
    private elementRef: ElementRef
  ) {}

  ngAfterViewInit(): void {
    this.initAnimations();
  }

  private initAnimations(): void {
    const section = this.elementRef.nativeElement;

    const title = section.querySelector('.about-title');
    if (title) {
      this.animationsService.observeElement(title, {
        type: 'slideInUp',
        duration: 1000
      });
    }

    const tabs = section.querySelectorAll('li[ngbNavItem]');
    tabs.forEach((tab: HTMLElement, index: number) => {
      this.animationsService.observeElement(tab, {
        type: 'scaleIn',
        delay: 400 + (index * 150)
      });
    });
  }
}